import { useAuthContext } from '../context/AuthContext';

/**
 * Access the current authenticated user and auth controls.
 * Must be used within an AuthProvider.
 *
 * @example
 * const { user, loading, logout } = useAuth();
 */
export const useAuth = () => useAuthContext();
